export default "__VITE_ASSET__CeFIRocR__"